"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComponents = exports.ComponentProvider = exports.Context = exports.Styled = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _emotionTheming = require("emotion-theming");

var _react2 = require("@mdx-js/react");

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var tags = ['p', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'pre', 'code', 'ol', 'ul', 'li', 'blockquote', 'hr', 'em', 'table', 'tr', 'th', 'td', 'em', 'strong', 'delete', // mdx
'wrapper', 'inlineCode', 'thematicBreak', // extras
'div'];
var aliases = {
  inlineCode: 'code',
  thematicBreak: 'hr',
  wrapper: 'div'
};

var alias = function alias(n) {
  return aliases[n] || n;
};

var themed = function themed(key) {
  return function (theme) {
    return theme.css((0, _lodash2.default)(theme, "styles.".concat(key)))(theme);
  };
};

var styled = function styled(tag, key) {
  return function (_ref) {
    var _ref$as = _ref.as,
        as = _ref$as === void 0 ? tag : _ref$as,
        props = _objectWithoutProperties(_ref, ["as"]);

    return (0, _core.jsx)(alias(as), _objectSpread({}, props, {
      css: themed(key)
    }));
  };
};

var components = {};

var Styled = _react.default.forwardRef(function (_ref2, ref) {
  var _ref2$tag = _ref2.tag,
      tag = _ref2$tag === void 0 ? 'div' : _ref2$tag,
      props = _objectWithoutProperties(_ref2, ["tag"]);

  var components = useComponents();
  var type = components[tag] || 'div';
  return (0, _core.jsx)(type, _objectSpread({}, props, {
    ref: ref
  }));
});

exports.Styled = Styled;

var createStyled = function createStyled(tag) {
  return _react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(Styled, _objectSpread({
      ref: ref,
      tag: tag
    }, props));
  });
};

tags.forEach(function (tag) {
  components[tag] = styled(tag, tag);
  Styled[tag] = createStyled(tag);
});

var createComponents = function createComponents() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = {};
  Object.keys(components).forEach(function (key) {
    next[key] = styled(components[key], key);
    Styled[key] = createStyled(key);
  });
  return next;
};

var noop = function noop(n) {
  return function () {
    return n;
  };
};

var baseContext = {
  theme: {
    css: noop
  },
  components: components
};

var Context = _react.default.createContext(baseContext);

exports.Context = Context;

var ComponentProvider = function ComponentProvider(_ref3) {
  var theme = _ref3.theme,
      components = _ref3.components,
      transform = _ref3.transform,
      props = _objectWithoutProperties(_ref3, ["theme", "components", "transform"]);

  var outer = (0, _react.useContext)(Context);
  var context = (0, _lodash.default)({}, outer, {
    theme: (0, _lodash.default)({}, theme, {
      css: transform
    }),
    components: createComponents(components)
  });
  return _react.default.createElement(_emotionTheming.ThemeProvider, {
    theme: context.theme
  }, _react.default.createElement(_react2.MDXProvider, {
    components: context.components
  }, _react.default.createElement(Context.Provider, {
    value: context
  }, props.children)));
};

exports.ComponentProvider = ComponentProvider;

var useComponents = function useComponents() {
  var context = (0, _react.useContext)(Context);
  return context.components;
};

exports.useComponents = useComponents;
